import React, { useEffect, useRef, useState } from "react";
import { Grid, Typography, Box, Button, Avatar, Select, FormControl, InputLabel } from "@material-ui/core";
import Loading from "../../../Shared/loading";
import ImageCapturePoly from "../../../Shared/ImageCapture";
import { Localizations } from "../../../Shared/sharedTypes";

interface propsType {
    photoTaken: (photo: Blob) => void;
    optOutOfPhoto: () => void;
    photo?: string;
    nextPhase: () => void;
    photoSavingApiCallCount: number;
    localizations: Localizations;
}
export default function PortraitPhoto({
    photo,
    photoTaken,
    nextPhase,
    photoSavingApiCallCount,
    localizations,
    optOutOfPhoto,
}: propsType) {
    const video = useRef<HTMLVideoElement>(null);
    const [imageCapture, setImageCapture] = useState<ImageCapture>();
    const [videoInputs, updateVideoInputs] = useState<MediaDeviceInfo[]>([]);
    const [currentVideoId, updateCurrentVideoId] = useState<string>();
    const [takingPhoto, updateTakingPhoto] = useState<boolean>(false);

    const [currentMediaStream, setStream] = useState<MediaStream | null>(null);

    function takePhoto(settings: PhotoSettings = { imageWidth: 600, imageHeight: 600 }) {
        if (imageCapture) {
            imageCapture
                .takePhoto(settings)
                .then((file: Blob) => {
                    updateTakingPhoto(false);
                    photoTaken(file);
                })
                .catch((err) => {
                    console.log("error taking photos");
                    console.log(err);
                    if (settings.imageWidth) {
                        console.log("trying again without any settings");
                        takePhoto({});
                    } else {
                        alert(localizations.issueTakingPhoto);
                    }
                });
        }
    }

    async function skipPhoto() {
        optOutOfPhoto();
    }

    useEffect(() => {
        navigator.mediaDevices.enumerateDevices().then((deviceList) => {
            var videoDevices = deviceList.filter((d) => d.kind === "videoinput");
            updateVideoInputs(videoDevices);
        });
    }, [])

    useEffect(() => {
        getDeviceList();
        if (video.current && takingPhoto) {
            startVideo(currentVideoId);
        }

        if (!takingPhoto) {
            stopTracks();
        }

        return () => {
            stopTracks();
        };
    }, [video, takingPhoto]);

    function changeVideoInput(inputDeviceLabel: string) {
        let device = videoInputs.find((v) => v.label === inputDeviceLabel);
        if (device) {
            startVideo(device.deviceId);
        }
    }

    function getDeviceList() {
        navigator.mediaDevices.enumerateDevices().then((deviceList) => {
            var videoDevices = deviceList.filter((d) => d.kind === "videoinput");
            updateVideoInputs(videoDevices);
            //If devices found, default current device to first in listif (videoDevices.length > 0) {
            updateCurrentVideoId(videoDevices[0].deviceId);
        });
    }

    function stopTracks() {
        if (currentMediaStream) {
            currentMediaStream.getTracks().forEach((t) => t.stop());
        }
    }

    const getConstaints = (inputDeviceId?: string, simple: number = 0) => {
        switch (simple) {
            case 0:
                return {
                    video: {
                        facingMode: inputDeviceId ? undefined : "user",
                        width: 800,
                        height: 800,
                        deviceId: inputDeviceId,
                        frameRate: 30,
                    },
                    audio: false,
                };
            case 1:
                return {
                    video: {
                        facingMode: inputDeviceId ? undefined : "user",
                        aspectRatio: 1,
                        deviceId: inputDeviceId,
                    },
                    audio: false,
                };
            case 2:
                return {
                    video: {
                        width: 800,
                        height: 800,
                        deviceId: inputDeviceId,
                    },
                    audio: false,
                };
            case 3:
                return {
                    video: {
                        deviceId: inputDeviceId,
                    },
                    audio: false,
                };
            case 4:
                return {
                    video: true,
                    audio: false,
                };
        }
    };

    function startVideo(inputDeviceId?: string, constraintIndex?: number) {
        stopTracks();
        var constraints = getConstaints(inputDeviceId, constraintIndex);
        console.log("getting user media", constraints);
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then((mediaStream) => {
                console.log("SUCCESS getting user media");
                var track = mediaStream.getVideoTracks()[0];
                setStream(mediaStream);
                updateCurrentVideoId(track.label);
                video.current!.srcObject = mediaStream;
                video.current!.onloadedmetadata = function (e) {
                    video.current!.play();
                };

                setImageCapture(new ImageCapturePoly(track));
            })
            .catch((err) => {
                console.log("Error getting user media");
                console.log(err);
                if ((constraintIndex ?? 0) < 4) {
                    console.log("Trying again with simpler constraints ");
                    startVideo(inputDeviceId, (constraintIndex ?? 0) + 1);
                } else {
                    alert(localizations.issueStartingVideo);
                }
            });
    }

    var opts = videoInputs.map((v) => (
        <option key={v.label} value={v.label}>
            {v.label}
        </option>
    ));
    return (
        <>
            {photoSavingApiCallCount === 0 && (
                <>
                    <Grid
                        item
                        className="PhaseTopSection"
                        zeroMinWidth
                        direction="column"
                        alignItems="stretch"
                        style={{
                            flex: 1,
                            display: "flex",
                        }}
                    >
                        <Box padding="16px 0px 0px 16px" text-textAlign="left" width="100%">
                            <Typography variant="h5">{localizations.profilePhoto}</Typography>
                        </Box>
                        <Box textAlign="center" width="100%">
                            {!takingPhoto && (
                                <div
                                    style={{
                                        width: "70%",
                                        height: 0,
                                        paddingTop: "70%",
                                        margin: "auto",
                                        overflow: "hidden",
                                        position: "relative",
                                    }}
                                >
                                    <Avatar
                                        src={photo}
                                        alt="Self portrait"
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            left: 0,
                                            objectFit: "scale-down",
                                        }}
                                    ></Avatar>
                                </div>
                            )}
                            <video
                                ref={video}
                                hidden={!takingPhoto}
                                autoPlay
                                muted
                                playsInline
                                style={{
                                    maxHeight: "90%",
                                    maxWidth: "90%",
                                    objectFit: "scale-down",
                                    margin: "auto",
                                    // borderRadius: "5%",
                                    width: "auto",
                                    height: "auto",
                                }}
                            ></video>
                        </Box>

                        {takingPhoto && videoInputs.length > 1 && (
                            <Box pl={2} pr={2}>
                                <FormControl
                                    fullWidth
                                // style={{
                                //     display: "flex",
                                // }}
                                >
                                    <InputLabel htmlFor="camera-select">{localizations.cameraToUse}</InputLabel>
                                    <Select
                                        native
                                        value={currentVideoId}
                                        onChange={(
                                            e: React.ChangeEvent<{
                                                value: unknown;
                                            }>
                                        ) => changeVideoInput(e.target.value as string)}
                                    >
                                        {opts}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                        <Box m={3} alignItems="center" textAlign="center">
                            {!photo && !takingPhoto && (
                                <Button
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    onClick={() => updateTakingPhoto(true)}
                                >
                                    {localizations.startCamera}
                                </Button>
                            )}
                            {takingPhoto && (
                                <Button variant="contained" size="large" color="primary" onClick={() => takePhoto()}>
                                    {localizations.capturePhoto}
                                </Button>
                            )}
                            {!!photo && !takingPhoto && (
                                <Button
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    onClick={() => updateTakingPhoto(true)}
                                >
                                    {localizations.retakePhoto}
                                </Button>
                            )}
                        </Box>
                        <Box m={3} alignItems="center" textAlign="center">
                            {!photo && !takingPhoto && (
                                <Button variant="contained" size="large" color="primary" onClick={() => skipPhoto()}>
                                    {localizations.skipPhoto}
                                </Button>
                            )}
                        </Box>
                        <Box m={1}>
                            <Typography variant="subtitle2" align="center">
                                {localizations.internalAuthenticationOnlyNotice}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item className="footer">
                        <Button
                            fullWidth
                            variant="contained"
                            size="large"
                            color="primary"
                            disabled={!photo}
                            onClick={nextPhase}
                        >
                            {localizations.next}
                        </Button>
                    </Grid>
                </>
            )}
            <Grid
                hidden={photoSavingApiCallCount === 0}
                item
                style={{
                    flex: 1,
                    textAlign: "center",
                }}
            >
                <Box textAlign="center">
                    <Loading message={localizations.settingImage}></Loading>
                </Box>
            </Grid>
        </>
    );
}
